import { useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCheckoutTransaction, useCreateTransaction } from 'features/transactions';
import { useGivingCreate } from '../../../../hooks';
import { useGiveNow } from '../../context/hooks';
import { GiveStepsEnum } from '../types';
import { SelectGiving, type SelectGivingFormValues } from './select-giving';
import { Summary } from './summary';

type P = {
  getPathToGivingDetail: (id: string) => string;
  paymentRedirectUrl: string;
  setStep: (step: GiveStepsEnum) => void;
  step: GiveStepsEnum;
};

const StepForm = ({ getPathToGivingDetail, paymentRedirectUrl, setStep, step }: P) => {
  const [billingInformation, setBillingInformation] = useState<SelectGivingFormValues>();
  const { clearViewerItems, viewerItems } = useGiveNow();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { createGiveNowRequestData } = useGivingCreate();
  const { isPending: isLoadingCreateTransaction, mutate: createTransaction } = useCreateTransaction();
  const { isPending: isLoadingCheckoutTransaction, mutate: checkoutTransaction } = useCheckoutTransaction();

  const onContinue = (values: SelectGivingFormValues) => {
    setBillingInformation(values);
    setStep(GiveStepsEnum.SUMMARY);
  };

  const onFinish = async () => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- This will be always defined
    const googleRecaptchaKey = await executeRecaptcha!('donation_create');
    createTransaction(createGiveNowRequestData({ billingInformation, googleRecaptchaKey, items: viewerItems }), {
      onSuccess({ id }) {
        checkoutTransaction(
          { id, pathname: paymentRedirectUrl },
          {
            onSuccess(paymentData) {
              window.location.href = paymentData.checkoutUrl;
              clearViewerItems();
            },
          },
        );
      },
    });
  };

  switch (step) {
    case GiveStepsEnum.OPTIONS:
      return <SelectGiving getPathToGivingDetail={getPathToGivingDetail} onContinue={onContinue} />;

    case GiveStepsEnum.SUMMARY:
      return (
        <Summary
          billingInformation={billingInformation}
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          isLoading={isLoadingCreateTransaction ?? isLoadingCheckoutTransaction}
          onContinue={onFinish}
          setStep={setStep}
        />
      );
  }
};

export default StepForm;
